import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Typography, Tag, DatePicker, Select, Space } from 'antd';
import { fetchAuditLogs } from '../../redux/slices/audit/auditThunk';
import { getUsersList } from '../../redux/slices/users/usersThunk';
import dayjs from 'dayjs';

const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

// --- DÉBUT AJOUT ---
// On définit la liste des actions possibles ici
const auditActions = ['CREATE', 'UPDATE', 'DELETE', 'ASSIGN', 'DISASSOCIATE'];
// --- FIN AJOUT ---

const AuditLogPage = () => {
  const dispatch = useDispatch();
  
  const [filters, setFilters] = useState({ page: 1, limit: 10 });

  const { logs, status } = useSelector((state) => state.audit);
  const { usersList } = useSelector((state) => state.users);

  useEffect(() => {
    dispatch(fetchAuditLogs(filters));
    if (!usersList.data?.data || usersList.data.data.length === 0) {
      dispatch(getUsersList({ page: 1, itemsPerPage: 1000, filter: {} }));
    }
  }, [dispatch, filters]); // J'ai retiré usersList.data d'ici car cela peut causer des re-render infinis
  
  const handleTableChange = (pagination) => {
    setFilters(prev => ({ ...prev, page: pagination.current, limit: pagination.pageSize }));
  };

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, page: 1 };
    
    if (key === 'dates') {
      if (value && value[0] && value[1]) {
        newFilters.startDate = dayjs(value[0]).startOf('day').toISOString();
        newFilters.endDate = dayjs(value[1]).endOf('day').toISOString();
      } else {
        delete newFilters.startDate;
        delete newFilters.endDate;
      }
      delete newFilters.dates; 
    } else {
      if (value) {
        newFilters[key] = value;
      } else {
        delete newFilters[key];
      }
    }

    setFilters(newFilters);
  };
  
  const columns = [
    { title: 'Date', dataIndex: 'timestamp', render: (text) => dayjs(text).format('DD/MM/YYYY HH:mm:ss'), sorter: true },
    { title: 'Utilisateur', dataIndex: ['user', 'email'], render: (email) => email || 'Système/Supprimé' },
    { title: 'Action', dataIndex: 'action', render: (action) => <Tag color="blue">{action}</Tag> },
    { title: 'Entité', dataIndex: 'entity' },
    { title: 'ID Entité', dataIndex: 'entityId' },
    { title: 'Détails', dataIndex: 'details', render: (details) => <pre style={{whiteSpace: 'pre-wrap', wordBreak: 'break-all'}}>{JSON.stringify(details, null, 2)}</pre> },
  ];

  return (
    <div>
      <Title level={2}>Journal d'Audit</Title>
      
      <Space style={{ marginBottom: 16 }} wrap>
        <Select
          placeholder="Filtrer par utilisateur"
          style={{ width: 250 }}
          onChange={(value) => handleFilterChange('userId', value)}
          allowClear
          loading={usersList.status === 'loading'}
        >
          {usersList.data?.data?.map(user => <Option key={user.id} value={user.id}>{user.email}</Option>)}
        </Select>

        {/* --- DÉBUT AJOUT --- */}
        <Select
          placeholder="Filtrer par action"
          style={{ width: 200 }}
          onChange={(value) => handleFilterChange('action', value)}
          allowClear
        >
          {auditActions.map(action => <Option key={action} value={action}>{action}</Option>)}
        </Select>
        {/* --- FIN AJOUT --- */}

        <RangePicker onChange={(dates) => handleFilterChange('dates', dates)} />
      </Space>

      <Table
        columns={columns}
        dataSource={logs.data}
        loading={status === 'loading'}
        rowKey="id"
        pagination={{
          current: filters.page,
          pageSize: filters.limit,
          total: logs.total,
        }}
        onChange={handleTableChange}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};

export default AuditLogPage;